import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { PolotnoStoreKeys, usePolotnoState } from '@/pages/AdvancedEditor/hooks/polotno-store';
import { runInAction } from 'mobx';
import { useEffect } from 'react';
import { updateCanvasSize } from './updateCanvasSize';

export const useCrop = () => {
    const { store } = useAdvancedEditorContext();
    const [cropSettings] = usePolotnoState(PolotnoStoreKeys.cropSettings);

    useEffect(() => {
        runInAction(() => {
            updateCanvasSize({ cropMode: cropSettings, store });
        });
    }, [cropSettings]);
};
